import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Order } from 'services';
import { ecommerce_manager } from 'utils/constants';
import { Results } from './components';

const OrderList = props => {
  let { account } = props;
  const Head = props => {
    let { handleCreateOpen, ...rest } = props;
    return (
      <GenericHeader
        header={account ? `Orders for ${account.displayname}` : "All Orders"}
        subheader="Order Management" {...rest} />
    );
  }

  return (
    <ListComp
      listing={Order.list}
      title="Orders"
      name="orders"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      roles={[ecommerce_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", account: account ? account.id : null }}
    />
  );
};

export default OrderList;
